import { formatCentsToDollar } from '../../../assets/currencies';
import { selectDues, useGetSubscriptionQuery } from '../api/billingApiLegacySlice';

type UnpaidInvoices = {
  totalDues: number;
  hasHierarchies: boolean;
  title: string;
};

type SubscriptionDues = {
  unpaidInvoices: UnpaidInvoices | null;
  isSubscriptionLoaded: boolean;
};

export function useUnpaidInvoices(): SubscriptionDues {
  const { totalDues, hasHierarchies, isSuccess } = useGetSubscriptionQuery(undefined, {
    selectFromResult: ({ data, isSuccess }) => ({ ...selectDues(data), isSuccess }),
  });

  return {
    unpaidInvoices:
      totalDues > 0 ? { totalDues, hasHierarchies, title: `Unpaid Invoices: ${formatCentsToDollar(totalDues)}` } : null,
    isSubscriptionLoaded: !!isSuccess,
  };
}
